<!-- Inline in Create Inventory -->
<nb-card *ngIf="this.isHumEdit; else dialogView" class="form-section-card">
  <nb-card-body [nbSpinner]="this.isLoading">
    <ng-container *ngTemplateOutlet="itemsSection"></ng-container>
  </nb-card-body>
</nb-card>

<ng-template #dialogView>
  <div class="edit-modal kw-dialog">

    <div class="modal-header">
      <div>
        <h2 class="modal-title">Adjust Quantity</h2>
        <div class="modal-subtitle">{{this.subtitle}}</div>
      </div>
      <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close()">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <div class="modal-body" [nbSpinner]="this.isLoading">
      <section class="form-section">
        <ng-container *ngTemplateOutlet="itemsSection"></ng-container>
      </section>

      <section class="form-section">
        <div class="section-head">
          <fa-icon [icon]="faFileLines" class="section-icon"></fa-icon>
          <h3>{{"Reason" | tenantWords}}</h3>
        </div>
        <mat-form-field appearance="outline" class="reason-field">
          <mat-label>{{"Reason" | tenantWords}}</mat-label>
          <mat-select id="reason" [(ngModel)]="this.reasonCodeId" name="reason" required>
            <mat-option *ngFor="let re of this.transactionReasons" [value]="re.id">
              {{re.reason}}
            </mat-option>
          </mat-select>
          <mat-hint>Recorded on the inventory transaction.</mat-hint>
        </mat-form-field>
      </section>
    </div>

    <div class="modal-footer">
      <button mat-stroked-button type="button" (click)="close()">Cancel</button>
      <button mat-raised-button color="primary" type="button" (click)="submit()">
        <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
      </button>
    </div>

  </div>
</ng-template>

<ng-template #itemsSection>
  <div class="section-head">
    <fa-icon [icon]="faListUl" class="section-icon"></fa-icon>
    <h3>{{this.isHumEdit ? 'Items on this Unit' : 'Items'}}</h3>
    <span class="count-pill">{{this.unit.handlingUnitDetails?.length ?? 0}}</span>
    <div class="section-actions" *ngIf="!this.isHumEdit">
      <button mat-button color="primary" type="button" (click)="addItem()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Add {{"Product" | tenantWords}}
      </button>
    </div>
  </div>

  <table class="hum-items" *ngIf="this.unit.handlingUnitDetails?.length; else noHumItems">
    <thead>
      <tr>
        <th>{{"Product" | tenantWords}}</th>
        <th>{{"Lot" | tenantWords}}</th>
        <th>UoM</th>
        <th>Weight</th>
        <th>Qty</th>
        <th><span class="visually-hidden">Remove</span></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let x of this.unit.handlingUnitDetails; trackBy: trackByIndex">
        <td class="item-cell">
          <div class="item-name">{{x.itemName}}</div>
          <div class="item-sub">{{x.itemDescription || 'No description'}}</div>
        </td>
        <td data-label="Lot">{{x.lotNumber || '—'}}</td>
        <td data-label="UoM">{{x.packageComponentWeightUnitOfMeasure || '—'}}</td>
        <td data-label="Weight">{{x.packageComponentWeight ? (this.getWeight(x) | number) : '—'}}</td>
        <td class="qty-cell">
          <input class="qty-input" [(ngModel)]="x.quantity" type="number" [attr.aria-label]="'Qty for ' + x.itemName">
        </td>
        <td class="remove-cell">
          <button mat-icon-button class="trash" type="button" [attr.aria-label]="'Remove ' + x.itemName"
            (click)="this.deleteItem(x)">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <ng-template #noHumItems>
    <div class="modal-empty">{{this.isHumEdit ? 'No items added yet' : 'No items on this unit'}}</div>
  </ng-template>
</ng-template>
